import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/auth';
import { supabase } from '@/integrations/supabase/client';

export const usePushNotificationWizard = () => {
  const { user } = useAuth();
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const checkWizardStatus = async () => {
      if (!user) {
        setShouldShow(false);
        return;
      }

      // Check if user has dismissed the wizard
      const dismissed = localStorage.getItem('push-wizard-dismissed');
      if (dismissed === 'true') {
        setShouldShow(false);
        return;
      }

      // Check if user already has OneSignal player ID (notifications enabled)
      const { data: profile } = await supabase
        .from('profiles')
        .select('onesignal_player_id')
        .eq('id', user.id)
        .single();

      // Show wizard if user doesn't have OneSignal setup
      if (!profile?.onesignal_player_id) {
        // Wait 2 seconds after login before showing
        setTimeout(() => setShouldShow(true), 2000);
      } else {
        setShouldShow(false);
      }
    };

    checkWizardStatus();
  }, [user]);

  const handleComplete = () => {
    setShouldShow(false);
    localStorage.setItem('push-wizard-dismissed', 'true');
  };

  const handleDismiss = () => {
    setShouldShow(false);
  };

  return {
    shouldShow,
    handleComplete,
    handleDismiss
  };
};
